import { Box, FormHelperText, Stack, TextField, TextFieldProps, Typography } from '@mui/material';
import { NumericFormatDecimal } from '@procureai/ui-mui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useSearchNumberRange } from './useSearchNumberRange';

interface SearchRangeSliderProps {
  title: string;
  attribute: string;
}

// Temporary NumberInput component that is going to be replaced with component from FormUi lib once available
type NumberInputFieldProps = Pick<TextFieldProps, 'placeholder' | 'helperText' | 'value' | 'onChange'>;
const NumberInputField = ({ helperText, ...props }: NumberInputFieldProps) => {
  const NumberInputComponent = useMemo(
    () =>
      NumericFormatDecimal({
        decimalScale: 0,
        allowNegative: true,
      }),
    [],
  );
  return (
    <Stack
      sx={{
        minWidth: 0,
      }}
    >
      <TextField
        variant="outlined"
        slotProps={{
          input: {
            inputComponent: NumberInputComponent as any,
            sx: {
              background: 'white',
            },
          },
        }}
        {...props}
      />
      <FormHelperText sx={{ overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
        {helperText}
      </FormHelperText>
    </Stack>
  );
};

export const SearchNumberRange = ({ title, attribute }: SearchRangeSliderProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SearchRangeSlider' });
  const { minInputProps, maxInputProps } = useSearchNumberRange({ attribute });

  return (
    <Box>
      <Typography variant="subtitle2">{title}</Typography>
      <Stack
        direction="row"
        sx={{
          gap: 2,
          display: 'flex',
          alignItems: 'baseline',
        }}
      >
        <NumberInputField placeholder={t('placeholder.min')} {...minInputProps} />
        <Typography variant="body1">{t('separator')}</Typography>
        <NumberInputField placeholder={t('placeholder.max')} {...maxInputProps} />
      </Stack>
    </Box>
  );
};
